import React, { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionADL } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionADLDetalleTransaccion from './components/SeccionADLDetalleTransaccion';
import SeccionADLDatosOperacion from './components/SeccionADLDatosOperacion';
import { useOperacionADL } from './hooks/useOperacionADL';


interface SistemaADLContentProps {
  operacion: OperacionADL,
  codSistema: number,
}

const SistemaADLContent = ({ operacion, codSistema }: SistemaADLContentProps) => {

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionADLDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionADLDetalleTransaccion
            operacion={operacion}
          />
        </Grid>

     

        <Grid item xs={12}>
          <Grid item xs={12}>
            <SeccionFirmas
              codSistema={SistemaTipo.ADL}
              idOperacion={operacion.id}
            />
          </Grid>
        </Grid>

      </Grid>
    </>
  )
}

function SistemaADL() {
  const { idOperacion, codSistema } = useContext<ContextOperacionType>(ContextOperacion)

  const { status, operacion, } = useOperacionADL(idOperacion)

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])


  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  else {

    if (!operacion) {
      return (
        <></>
      )
    }
  }

  return (
    <SistemaADLContent
      operacion={operacion}
      codSistema={codSistema}
    />
  )
}

export default SistemaADL;
